import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/marketing/svendetid-landing/SvendetidLanding.tsx");
